// extracted by mini-css-extract-plugin
export default {"wrapProductTableHeader":"product-table-header_wrapProductTableHeader__QFjYl"};